module.exports = __webpack_public_path__ + "img/logo-cbgr.e90e05e3.svg";